import React from "react";
import Sidebar from "./Sidebar";
import { Outlet } from "react-router-dom";
import { useLocalization } from "./Localization/Localization";
import Header from "./Header";

function Wrapper() {
  const { locale } = useLocalization();
  const [visible, setVisible] = React.useState(false);
  return (
    <div
      className={locale == "ar" ? "main-wrapper directions" : "main-wrapper"}
      onClick={() => {
        if (visible) {
          setVisible(false);
        }
      }}
    >
      <Header setVisible={setVisible} visible={visible} />
      <Sidebar setVisible={setVisible} visible={visible} />
      <div>
        <Outlet />
      </div>
    </div>
  );
}

export default Wrapper;
